import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  menuitem: {
    fontSize: '1.2rem',
    color: '#1A1C19',
    fontWeight: 500,
    borderBottom: '1px solid #DEE5DA',

    '&:last-child': {
      borderBottom: 'none',
    },

    '&.Mui-selected': {
      color: '#727970',
      backgroundColor: 'transparent',
    },
  },
}))
